import { ObservationAttachment } from '../Attachment';
import React, { useEffect } from 'react';
import { useNotify } from '../../../../../../hooks';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { Modal } from '@lifeomic/chroma-react/components/Modal';
import { useModalStyles } from './styles';
import ReactJson from 'react-json-view';
import { useTheme } from '@lifeomic/chroma-react/styles';
import { defineMessages, useIntl } from 'react-intl';
import useFhirSearch, {
  Hits,
} from '../../../../../Surveys/util/FhirSearch/useFhirSearch';

const messages = defineMessages({
  observationError: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.observationViewModal.observationError',
    defaultMessage: 'Error loading observation',
  },
});

type ObservationViewModalProps = {
  attachment: ObservationAttachment;
  onDismiss: () => void;
};

export const ObservationViewModal = (props: ObservationViewModalProps) => {
  const { attachment, onDismiss } = props;
  const theme = useTheme();
  const classes = useModalStyles();
  const { formatMessage } = useIntl();
  const [notify] = useNotify();

  const [response, isLoading] = useFhirSearch<Hits<fhir.Observation>>({
    type: 'select',
    columns: '*',
    from: [{ table: 'observation' }],
    limit: [
      { type: 'number', value: 0 },
      { type: 'number', value: 1 },
    ],
    where: {
      type: 'elasticsearch',
      query: {
        bool: {
          must: [
            {
              term: {
                'id.keyword': attachment.resource.id,
              },
            },
          ],
        },
      },
    },
  });

  const observation = response?.hits?.hits[0]?._source;

  const hasError = !isLoading && !observation;

  useEffect(() => {
    if (hasError) {
      notify(formatMessage(messages.observationError), 'error');
      onDismiss();
    }
  }, [hasError, notify, formatMessage, onDismiss]);

  return (
    <Modal
      isFullScreen
      isOpen={true}
      onDismiss={onDismiss}
      contentClassName={classes.modalContent}
      data-testid="observation-view-modal"
    >
      {isLoading ? (
        <Box fullWidth fullHeight justify="center" align="center">
          <DotLoader />
        </Box>
      ) : (
        <Box padding={4}>
          {!!observation && (
            <ReactJson
              src={observation}
              style={{ fontFamily: theme.typography.fontFamily }}
              displayDataTypes={false}
              displayObjectSize={false}
            />
          )}
        </Box>
      )}
    </Modal>
  );
};
